// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"770cfa5cf9facdabcdee","731":"e5f54201d9313d994fa8","843":"7856e69892d5d2bd2262","883":"e98c9c0664e640425893"}[chunkId] + ".js";
};